/**
 * Keyboard capability (src/platform/).
 *
 * Contract: every capability has a working web implementation; native
 * branches (via isNativePlatform()) MUST keep the web fallback. The viewport
 * resize itself is configured in capacitor.config.ts (Keyboard.resize:
 * 'native'); this seam only handles the runtime call that hides the iOS
 * accessory bar (up/down/done), which is not a config option in Capacitor 8.
 * Web is a complete no-op.
 */

import { getPlatform } from './detection'

/** Hide the iOS keyboard accessory bar; silent no-op on web and Android. */
export function initKeyboard(): void {
  // setAccessoryBarVisible is an iOS-only call — on Android the Keyboard
  // plugin rejects it as UNIMPLEMENTED on every launch. Gate on iOS so the
  // native branch runs only where the accessory bar exists.
  if (getPlatform() !== 'ios') return
  void import('@capacitor/keyboard')
    .then(({ Keyboard }) => Keyboard.setAccessoryBarVisible({ isVisible: false }))
    .catch(() => undefined)
}
